import bootstrapSaga from './bootstrapSaga';
import startSaga from './startSaga';
import webSocketSaga from './websocketSaga';
import convoSaga from './conversationSaga';
import formSaga from './formSaga';
import videoSaga from './videoSaga';
import actionSaga from './actionSaga';
import { fork, all } from 'redux-saga/effects';

export default function* rootSaga() {
    yield all([
        fork(bootstrapSaga),
        fork(startSaga),
        fork(webSocketSaga),
        fork(convoSaga),
        fork(formSaga),
        fork(videoSaga),
        fork(actionSaga),
    ]);
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/index.ts